<div class="myPurchase-dialog-container">
  <div class="myPurchase-dialog-header">
    Duplicated files detected
    <!-- <button mat-button class="closeBtn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>
  <div class="myPurchase-dialog-content">
    <div class="error-message">
      <p>Do you want to replace the existing file with a new version or keep both files?</p>
      <p>File name: {{ input.contentMsg }}</p>
      <mat-radio-group aria-labelledby="replaceExisingFile" class="replace-existing-rd-grp" name="replaceExistingRdGrp"
        (change)="replaceExisingFile($event)" [(ngModel)]="replaceChoice" [ngModelOptions]="{standalone: true}">
        <mat-radio-button class="part-model-rd" *ngFor="let choice of choices" [value]="choice">
          {{choice}}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="myPurchase-dialog-actions">
    <div mat-dialog-actions>
      <app-button class="padBtn" name="Cancel" (click)="close()"></app-button>
      <app-button class="padBtn actionBtn" type="flat-button" name="{{ input.btnNameTwo }}" (click)="input.clickTwo()"
        [ngStyle]="{'display': (input.btnNameTwo == '' ? 'none' : 'block')}"></app-button>
    </div>
  </div>
</div>